<template>
    <el-dialog
        title="消息回复"
        :visible.sync="visible"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="replaymodal"
    >
        <el-form
            label-width="100px"
        >
            <el-form-item label="回复方：">回复方回复方回复方回复方回复方回复方回复方回复方</el-form-item>
            <el-form-item label="回复内容：">
                <el-input
                    type="textarea"
                    maxlength="200"
                    rows="5"
                    v-model="content"
                ></el-input>
            </el-form-item>
        </el-form>
        <div class="replaymodal-btns">
            <el-button size="medium" @click="closeModal">关闭</el-button>
            <el-button size="medium" type="primary" @click="replayHandle">回复</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            content: ''
        }
    },
    methods: {
        open(row) {
            this.visible = true;
        },
        replayHandle() {
            console.log(this.content)
            this.closeModal();
        },
        closeModal() {
            this.visible = false;
        }
    }
}
</script>

<style lang="less" scoped>
.replaymodal {
    .replaymodal-btns {
        margin-top: 40px;
        text-align: center;
    }
}
</style>